export default "__VITE_ASSET__09e640be__"